module.exports = __webpack_public_path__ + "static/media/S15_B.07cd725a.png";